import { Dispatch, useEffect } from 'react';
import ConfigState from '../state/config-state';
import Action from '../../state/action';
import ParsedConfig from '../parse/types/parsed-config';

const useConfig = (config: ConfigState, dispatch: Dispatch<Action>, parsedConfig: ParsedConfig) => {
  useEffect(() => {
    if (config.type === 'default') dispatch({ type: 'parse-config', parsedConfig });
  }, []);
};

export default useConfig;
